"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SectionWrapper = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _hooks = require("../../../hooks");
var _Icon = require("../Icons/PetSure/Icon");
require("./accordionSection.scss");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SectionWrapper = _ref => {
  let {
    id,
    heading,
    content,
    children,
    footer,
    openIcon = null,
    closeIcon = null,
    isOpen = true,
    isFixed = false,
    validateBeforeClose = false,
    validateOnChange = undefined,
    onChange,
    customCssClass,
    headerButtonCustomLabel,
    headerButtonCssClass,
    customTrackingData,
    customTrackingEvents,
    headerIcon = null,
    headerIconColor = null,
    borderSideOption = null
  } = _ref;
  const [panelIsOpen, setPanelIsOpen] = (0, _react.useState)(isOpen || isFixed);
  const accordionControl = (0, _react.useRef)(null);
  const panelId = id || "accordion_".concat(Date.now());
  const contentId = "".concat(panelId, "_content");
  const controlId = "".concat(panelId, "_control");
  const hasFooter = typeof footer !== 'undefined';
  (0, _react.useEffect)(() => {
    setPanelIsOpen(isOpen);
  }, [isOpen, setPanelIsOpen]);
  const TogglePanelOpenState = () => {
    const newState = !panelIsOpen;
    if (!newState && validateBeforeClose && typeof validateOnChange !== 'undefined') {
      validateOnChange().then(isValid => {
        if (isValid) {
          setPanelIsOpen(newState);
          if (onChange) {
            onChange(newState);
          }
        }
      });
      return;
    }
    setPanelIsOpen(newState);
    if (onChange) {
      onChange(newState);
    }
  };
  const customSectionHeader = typeof heading !== 'string' && !headerButtonCustomLabel;
  (0, _hooks.useTracking)({
    elementRef: accordionControl,
    trackingProps: {
      label: heading,
      panelIsOpen: isOpen
    },
    customTrackingData,
    customTrackingEvents
  });
  const SectionIcon = () => headerIcon ? /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: headerIcon,
    style: {
      color: headerIconColor
    }
  }) : null;
  return /*#__PURE__*/_react.default.createElement("section", {
    className: "accordionSection ".concat(borderSideOption ? "overrideAccordionBorder_".concat(borderSideOption) : '', " ").concat(customCssClass || '', " ").concat(panelIsOpen || isFixed ? 'open' : 'closed', " ").concat(isFixed ? 'fixed' : '')
  }, /*#__PURE__*/_react.default.createElement("header", {
    className: "accordionSectionHeader ".concat(customSectionHeader || isFixed ? 'accordionSectionHeader_custom' : '')
  }, customSectionHeader ? /*#__PURE__*/_react.default.createElement("div", {
    className: "accordionCustomHeading"
  }, /*#__PURE__*/_react.default.createElement(SectionIcon, null), heading) : /*#__PURE__*/_react.default.createElement("h3", null, isFixed ?
  /*#__PURE__*/
  // eslint-disable-next-line react/jsx-no-useless-fragment
  _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(SectionIcon, null), heading) : /*#__PURE__*/_react.default.createElement("button", {
    ref: accordionControl,
    "aria-controls": contentId,
    "aria-expanded": panelIsOpen,
    id: controlId,
    onClick: () => TogglePanelOpenState(),
    type: "button",
    className: "accordionControl ".concat(headerButtonCssClass || '')
  }, headerButtonCustomLabel ?
  /*#__PURE__*/
  // eslint-disable-next-line react/jsx-no-useless-fragment
  _react.default.createElement(_react.default.Fragment, null, headerButtonCustomLabel) : /*#__PURE__*/_react.default.createElement("span", {
    className: "labelText"
  }, /*#__PURE__*/_react.default.createElement(SectionIcon, null), heading), panelIsOpen ? /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: openIcon || 'caret_up'
  }) : /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: closeIcon || 'caret_down'
  })))), /*#__PURE__*/_react.default.createElement("section", {
    className: "accordionSectionContent",
    id: contentId,
    "aria-labelledby": controlId
  }, content, children, hasFooter && /*#__PURE__*/_react.default.createElement("footer", null, footer)));
};
exports.SectionWrapper = SectionWrapper;
SectionWrapper.propTypes = {
  id: _propTypes.default.string,
  isOpen: _propTypes.default.bool,
  isFixed: _propTypes.default.bool,
  validateBeforeClose: _propTypes.default.bool,
  validateOnChange: _propTypes.default.func,
  onChange: _propTypes.default.func,
  openIcon: _propTypes.default.string,
  closeIcon: _propTypes.default.string,
  heading: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  content: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  footer: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  customCssClass: _propTypes.default.string,
  headerButtonCustomLabel: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  headerButtonCssClass: _propTypes.default.string,
  // eslint-disable-next-line react/forbid-prop-types
  children: _propTypes.default.any,
  // eslint-disable-next-line react/forbid-prop-types
  customTrackingData: _propTypes.default.any,
  customTrackingEvents: _propTypes.default.arrayOf(_propTypes.default.string),
  headerIcon: _propTypes.default.string,
  headerIconColor: _propTypes.default.string,
  borderSideOption: _propTypes.default.oneOf(['top', 'bottom', null])
};
var _default = exports.default = SectionWrapper;